import { defaultInstance } from '../api/httpClient';

interface PageBody<T> {
  data?: T[];
  total_pages?: number;
}

/** Hard stop so a bad total_pages can never loop forever. */
const MAX_PAGES = 50;

/**
 * Reads every page of a list endpoint ({ data, page, total_pages }) and returns the rows in order.
 * crud answers 100 rows by default (max 200), so a single GET loses everything past the first page.
 */
export const fetchAllPages = async <T>(url: string, limit = 100): Promise<T[]> => {
  const read = (page: number) =>
    defaultInstance<PageBody<T>>({ url, method: 'GET', params: { page, limit } }) as unknown as Promise<PageBody<T>>;

  const first = await read(1);
  const rows = [...(first?.data || [])];
  const totalPages = Math.min(first?.total_pages || 1, MAX_PAGES);
  for (let page = 2; page <= totalPages; page++) {
    const next = await read(page);
    rows.push(...(next?.data || []));
  }
  return rows;
};
